import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject, input } from '@angular/core';
import { AssetDto, GalleryDto, GalleryFeedbackOptions } from '@nusign/picflow-backend-types';
import { ShareAssetDialogComponent } from '../../../gallery/dialogs/share-asset-dialog/share-asset-dialog.component';
import { GROWTHBOOK } from '../../../growthbook';
import { DialogService } from '../../../services/dialog.service';
import { StateService } from '../../../services/state.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-asset-side-menu',
  templateUrl: './asset-side-menu.component.html',
  styleUrls: ['./asset-side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent],
})
export class AssetSideMenuComponent {
  public state = inject(StateService);
  private dialog = inject(DialogService);
  public growthBook = inject(GROWTHBOOK);

  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Output() onThumbnailBarOpen = new EventEmitter();
  @Output() onModeChange = new EventEmitter();
  @Input() asset: AssetDto;
  @Input() clientMode: boolean;
  @Input() thumbnailBarOpen: boolean;
  @Input() isDesktop: boolean;
  @Input() mode: 'info' | 'activity' = 'info';
  gallery = input.required<GalleryDto>();
  galleryPermissions = input.required<GalleryDto['permissions']>();
  allowedAndEnabledFeedbackOptions = input<GalleryFeedbackOptions[]>();

  close() {
    this.onClose.emit();
  }

  openShareDialog() {
    this.dialog.open(ShareAssetDialogComponent, {
      gallery: this.gallery(),
      asset: this.asset,
    });
  }

  switchMode(mode: 'info' | 'activity') {
    this.mode = mode;
    this.onModeChange.emit(mode);
  }
}
